import { TIPO_INSPECAO } from "@/contexts/cadastro/estabelecimento";
import { RelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/model/RelatorioAM";
import { Col, DatePicker, Form, Input, Row } from "antd";
import dayjs from "dayjs";

export function FormPreviewRAM({
  relatorio,
}: {
  relatorio: RelatorioAM | undefined;
}) {
  return (
    <>
      <Form layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Estabelecimento">
              <Input
                disabled
                value={`${relatorio?.estabelecimento?.numeroInspecao} - ${relatorio?.estabelecimento ? TIPO_INSPECAO[relatorio.estabelecimento.tipoInspecao] : "SISE"} - ${relatorio?.estabelecimento?.nome}`}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Formulário">
              <Input disabled value={relatorio?.formulario?.nome} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Proprietário">
              <Input disabled value={relatorio?.proprietario?.nome} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Inspetor/Monitor">
              <Input
                disabled
                value={
                  relatorio?.inspetor?.nome || relatorio?.inspetor?.nomePessoa
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Responsável Técnico">
              <Input disabled value={relatorio?.responsavelTecnico} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Data da Monitoria">
              <DatePicker
                disabled
                format="DD/MM/YYYY"
                value={
                  relatorio?.dataMonitoria
                    ? dayjs(relatorio.dataMonitoria)
                    : undefined
                }
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          {relatorio?.observacao && (
            <Col xs={24}>
              <Form.Item label="Observação">
                <Input.TextArea
                  disabled
                  rows={3}
                  value={relatorio.observacao}
                />
              </Form.Item>
            </Col>
          )}
        </Row>

        <Row>
          <Col xs={24}>
            <Form.Item label="Conclusão">
              <Input.TextArea disabled rows={3} value={relatorio?.conclusao} />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item label="Ação Fiscal">
              <Input.TextArea
                disabled
                rows={3}
                value={relatorio?.acaoFiscal || ""}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
